import Account from "./Account";
import Bundle from "./Bundle";
import Chain from "./Chain";
import Connect from "./Connect";
import Expired from "./Expired";
import General from "./General";
import Numeric from "./Numeric";
import Plugin from "./Plugin";
import Proxy from "./Proxy";
import Token from "./Token";

const Warning = {
  Account,
  Numeric,
  Bundle,
  Chain,
  Connect,
  Expired,
  General,
  Plugin,
  Proxy,
  Token,
};

export default Warning;
